import {ChangeDetectionStrategy, Component, computed, HostListener, inject} from '@angular/core';
import {TranslatePipe} from '@brunata-angular/util';
import {QuickExportsFormService, quickExportsFormProviders} from './quick-exports-form.service';
import {HasUnsavedChanges} from '@brunata-angular/ui';
import {ActionButtonComponent} from '../shared/ui/action-button/action-button.component';
import {StepFlowComponent} from '../steps/step-flow/step-flow.component';
import {flowSlots} from '../shared/models/export-flow-slots.model';
import {quickFlowSteps} from './quick-exports.model';
import {ExportTestButtonComponent} from '../shared/ui/export-test-button/export-test-button.component';

@Component({
    standalone: true,
    imports: [TranslatePipe, ActionButtonComponent, ExportTestButtonComponent, StepFlowComponent],
    templateUrl: './quick-exports.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: quickExportsFormProviders,
})
export class QuickExportsComponent implements HasUnsavedChanges {
    protected readonly quickExportFormService = inject(QuickExportsFormService);

    protected readonly isSpecificDateMode = computed(
        () => this.quickExportFormService.selectedMode() === 'specific-date',
    );

    protected readonly steps = computed(() =>
        quickFlowSteps(
            this.isSpecificDateMode()
                ? flowSlots(['usage', 'readingDate'], {without: ['columns', 'schedule']})
                : flowSlots(['usage', 'name'], {without: ['columns']}),
            this.quickExportFormService,
        ),
    );

    @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload(event: BeforeUnloadEvent): void {
        if (this.hasUnsavedChanges()) {
            event.preventDefault();
        }
    }

    hasUnsavedChanges(): boolean {
        return this.quickExportFormService.hasUnsavedChanges();
    }
}
